export enum CHECKOUT_KEYS {
  ORDER_PREFIX = 'order-',
  CHECKOUT_DATA = 'checkout_data',
  SHIPPING_DATA = 'shipping_data',
  PAYMENT_DATA = 'payment_data',
}

export enum CART_LOCAL_STORAGE_KEY {
  CURRENT_CART = 'current_cart',
  CHECKOUT_DATA = 'checkout_data',
}

export enum CART_STATUS {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  ABANDONED = 'ABANDONED',
}
export enum CART_SHIPPING_STATUS {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  IN_TRANSIT = 'IN_TRANSIT',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
export enum CART_PAYMENT_STATUS {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}
